(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lh-favoris-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Storage key and batch size constants
  const STORAGE_KEY = 'lhFavorites';
  const BATCH_SIZE  = 20;
  const ROOT_URL = window.Shopify?.routes?.root || '/';
  const section = document.querySelector('.lh-favoris-section');
  const removeLabel = section?.dataset.removeLabel || '';

  // Retrieve favorites from localStorage
  const getFavorites = () => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch { return []; }
  };

  // Save updated favorites list
  const setFavorites = favs =>
    localStorage.setItem(STORAGE_KEY, JSON.stringify(favs));

  // Remove a single favorite by handle
  const removeFavorite = handle => {
    const newFavs = getFavorites().filter(h => h !== handle);
    setFavorites(newFavs);
    return newFavs;
  };

  // Generate HTML for one product card
  const renderCard = product => {
    const img   = product.images[0];
    const price = (product.price / 100)
      .toLocaleString(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || section?.dataset.currency || 'EUR' });
    const productUrl = `${ROOT_URL}products/${encodeURIComponent(product.handle)}`;
    return `
      <li class="lh-favoris-card">
        <button class="lh-favoris-remove-btn" data-handle="${product.handle}" aria-label="${removeLabel}">
          <!-- Heart SVG icon -->
          <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.869629 5.42258C0.869629 2.60519 3.34267 0.434753 6.24354 0.434753C7.73885 0.434753 9.05572 1.13597 10.0001 2.0438C10.9444 1.13597 12.2602 0.434753 13.7566 0.434753C16.6575 0.434753 19.1305 2.60519 19.1305 5.42258C19.1305 7.35301 18.3072 9.04971 17.1667 10.4855C16.0293 11.9172 14.5392 13.1328 13.1138 14.121C12.5681 14.4988 12.0182 14.8462 11.5131 15.1029C11.0404 15.344 10.4957 15.5652 10.0001 15.5652C9.50441 15.5652 8.96076 15.344 8.48702 15.1029C7.93331 14.8103 7.39899 14.4823 6.88737 14.121C5.46093 13.1328 3.97189 11.9172 2.83345 10.4855C1.69293 9.04971 0.869629 7.35301 0.869629 5.42258ZM6.24354 1.99997C4.07311 1.99997 2.43485 3.59649 2.43485 5.42258C2.43485 6.88658 3.05676 8.25041 4.0585 9.51093C5.06232 10.7735 6.41363 11.889 7.7785 12.8344C8.29502 13.1923 8.78024 13.496 9.19763 13.7088C9.64424 13.9363 9.90302 14 10.0001 14C10.0971 14 10.3559 13.9363 10.8035 13.7078C11.2955 13.4485 11.7695 13.1567 12.2227 12.8344C13.5865 11.889 14.9378 10.7746 15.9416 9.51093C16.9434 8.25041 17.5653 6.88658 17.5653 5.42258C17.5653 3.59649 15.927 1.99997 13.7566 1.99997C12.5107 1.99997 11.3462 2.74397 10.6209 3.68936C10.5479 3.78459 10.4539 3.86174 10.3462 3.91483C10.2385 3.96792 10.1201 3.99553 10.0001 3.99553C9.88003 3.99553 9.7616 3.96792 9.65394 3.91483C9.54628 3.86174 9.45227 3.78459 9.37919 3.68936C8.65398 2.74397 7.4905 1.99997 6.24354 1.99997Z" fill="#050B0B"/>
            <path d="M2.43485 5.42258C2.43485 3.59649 4.07311 1.99997 6.24354 1.99997C7.4905 1.99997 8.65398 2.74397 9.37919 3.68936C9.45227 3.78459 9.54628 3.86174 9.65394 3.91483C9.7616 3.96792 9.88003 3.99553 10.0001 3.99553C10.1201 3.99553 10.2385 3.96792 10.3462 3.91483C10.4539 3.86174 10.5479 3.78459 10.6209 3.68936C11.3462 2.74397 12.5107 1.99997 13.7566 1.99997C15.927 1.99997 17.5653 3.59649 17.5653 5.42258C17.5653 6.88658 16.9434 8.25041 15.9416 9.51093C14.9378 10.7746 13.5865 11.889 12.2227 12.8344C11.7695 13.1567 11.2955 13.4485 10.8035 13.7078C10.3559 13.9363 10.0971 14 10.0001 14C9.90302 14 9.64424 13.9363 9.19763 13.7088C8.78024 13.496 8.29502 13.1923 7.7785 12.8344C6.41363 11.889 5.06232 10.7735 4.0585 9.51093C3.05676 8.25041 2.43485 6.88658 2.43485 5.42258Z" fill="#050B0B"/>
          </svg>
        </button>
        <a href="${productUrl}">
          <div class="lh-favoris-card__media">
            <img src="${img}" alt="${product.title}">
          </div>
          <h3 class="lh-favoris-card__title">${product.title}</h3>
          <p class="lh-favoris-card__price">${price}</p>
        </a>
      </li>`;
  };

  // Fetch product data for a batch of handles
  const fetchBatch = handles =>
    Promise.all(
      handles.map(h =>
        fetch(`${ROOT_URL}products/${encodeURIComponent(h)}.js`)
          .then(r => (r.ok ? r.json() : null))
          .catch(() => null)
      )
    );

  document.addEventListener('DOMContentLoaded', async () => {
    const grid     = document.getElementById('lh-favoris-grid');
    const empty    = document.getElementById('lh-favoris-empty');
    const loadMore = document.getElementById('lh-favoris-load-more');
    const allHandles = getFavorites();

    let offset = 0;

    // Hide states until initial load completes
    empty.style.display    = 'none';
    loadMore.style.display = 'none';

    if (allHandles.length === 0) {
      // Show empty message if no favorites
      empty.style.display = '';
      return;
    }

    // Load first batch of products
    const initialBatch = allHandles.slice(offset, offset + BATCH_SIZE);
    const products = await fetchBatch(initialBatch);
    products.filter(Boolean).forEach(prod =>
      grid.insertAdjacentHTML('beforeend', renderCard(prod))
    );
    offset += BATCH_SIZE;

    // Show load-more button if more items remain
    if (offset < allHandles.length) {
      loadMore.style.display = '';
    }

    // Remove favorite handler
    grid.addEventListener('click', e => {
      const btn = e.target.closest('.lh-favoris-remove-btn');
      if (!btn) return;
      const handle = btn.dataset.handle;
      const remaining = removeFavorite(handle);
      btn.closest('.lh-favoris-card').remove();
      if (remaining.length === 0) {
        empty.style.display = '';
        loadMore.style.display = 'none';
      }
    });

    // Load more handler
    loadMore.addEventListener('click', async () => {
      const nextBatch = allHandles.slice(offset, offset + BATCH_SIZE);
      const more = await fetchBatch(nextBatch);
      more.filter(Boolean).forEach(prod =>
        grid.insertAdjacentHTML('beforeend', renderCard(prod))
      );
      offset += BATCH_SIZE;
      if (offset >= allHandles.length) {
        loadMore.style.display = 'none';
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
